require('../sass/style.scss');



//////////////////
// WEBPACK FOOTER
// ./build/css.js
// module id = 760
// module chunks = 0